export const MAX_MULTIPART_SEGMENTS = 3;
export const RECOGNISED_MULTIPART_EXTENSIONS = new Set([
    // --- Archive formats ---
    'tar.gz',
    'tar.bz2',
    'tar.xz',
    'tar.zst',
    'tar.lz',
    'tar.lz4',
    'tar.lzo',
    'tar.z',
    'tar.sz',
    'tar.br',
    'tar.snz',
    'tar.lrz',
    // --- Signed or split archives ---
    'tar.gz.sig',
    'tar.gz.asc',
    'tar.bz2.sig',
    'tar.bz2.asc',
    'tar.xz.sig',
    'tar.xz.asc',
    'tar.zst.sig',
    'tar.zst.asc',
    'tar.gz.00',
    'tar.gz.01',
    'tar.gz.part',
    // --- Compressed plain files ---
    'xml.gz',
    'json.gz',
    'csv.gz',
    'txt.gz',
    'log.gz',
    'sql.gz',
    'yaml.gz',
    'yml.gz',
    'js.gz',
    'css.gz',
    'html.gz',
    'md.gz',
    'xml.xz',
    'json.xz',
    'xml.zst',
    // --- Web / JS build artifacts ---
    'js.map',
    'css.map',
    'mjs.map',
    'cjs.map',
    'min.js.map',
    'min.css.map',
    'bundle.js.map',
    'bundle.css.map',
    // --- Fonts and assets ---
    'ttf.woff',
    'otf.woff',
    'ttf.woff2',
    'otf.woff2',
    // --- Certificates / crypto ---
    'pem.crt',
    'pem.key',
    'crt.pem',
    'cer.pem',
    'key.pem',
    'csr.pem',
    'pfx.pem',
    'p12.pem',
    'der.pem',
    // --- Container / signature formats ---
    'apk.sig',
    'zip.sig',
    'zip.asc',
    'jar.sig',
    'jar.asc',
    // --- Other software-specific combos ---
    'wasm.gz',
    'svg.gz',
    'woff2.br',
    'wasm.br',
    // --- Less common multi-layer formats ---
    'tar.lzma',
    'tar.brotli',
    'tar.zpaq',
    'tar.arj',
]);
